import { useEffect, useMemo } from 'react';
import { ACCESS_ERROR_MESSAGES } from '../error/accessErrorMessages';
import { ErrorPageShell } from '../error/ErrorPageShell';
import { resolveErrorPageVariant } from '../error/errorPageVariant.util';
import { ErrorStateCard } from '../error/ErrorStateCard';
import { ROUTE_PATHS } from '../routes/routePaths';
import { buildBaseErrorLogPayload, logError } from '../services/errorLogger';
import { contactUsEmail } from '../util/constants';

function PublicAccessError() {
  const variant = resolveErrorPageVariant(403);

  // Nothing upstream generates/passes a correlationId here — building and logging
  // one (same self-contained pattern as NotFoundComponent) is what makes the
  // reference block (Ref./Copy/Email) show up at all.
  const errorPayload = useMemo(
    () => buildBaseErrorLogPayload('ui-action', 'warning', ACCESS_ERROR_MESSAGES.title),
    []
  );

  useEffect(() => {
    void logError(errorPayload);
  }, [errorPayload]);

  return (
    <ErrorPageShell secondaryText={variant.secondaryText} secondaryActionLabel={variant.secondaryActionLabel}>
      <ErrorStateCard
        icon={variant.icon}
        badgeIcon={variant.badgeIcon}
        illustration={variant.illustration}
        title={ACCESS_ERROR_MESSAGES.title}
        correlationId={errorPayload.correlationId}
        logPayload={errorPayload}
        goHomeLabel={ACCESS_ERROR_MESSAGES.ctaLabel}
        onGoHome={() => window.location.assign(ROUTE_PATHS.HOME)}
        description={
          <p>
            {ACCESS_ERROR_MESSAGES.descriptionBeforeSupport}
            <a href={`mailto:${contactUsEmail}`}>
              {ACCESS_ERROR_MESSAGES.supportLinkLabel}
            </a>
            {ACCESS_ERROR_MESSAGES.descriptionAfterSupport}
          </p>
        }
      />
    </ErrorPageShell>
  );
}

export default PublicAccessError;
